import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { StatusViewService } from "../../shared/services/status-view.service";
import { Store } from "@ngrx/store";
import { AccountInfoActions } from "../actions";
import { selectMasterAccount, selectSubAccountId } from "../reducers";
import { catchError, exhaustMap, map, of } from "rxjs";
import { VerifyTaxWithholdingsRequest } from "../../shared/models/VerifyTaxWithholdingsRequest";
import { VerifyTaxWithholdingsResponse } from "../../shared/models/VerifyTaxWithholdingsResponse";
import { ServiceErrorAccountData } from "../../create-request/models/shared/ServiceError";
import { SubmitTaxWithholdingsRequest } from "../../shared/models/SubmitTaxWithholdingsRequest";
import { concatLatestFrom } from "@ngrx/operators";

@Injectable()
export class UpdateTweModalEffects {
    constructor(
        private actions$: Actions,
        private statusViewService: StatusViewService,
        private store: Store
      ) { }

    verifyTaxWithholdings$ = createEffect(() =>
        this.actions$.pipe(ofType(
            AccountInfoActions.verifyTaxWithholdings
        ),
        concatLatestFrom(() => [
            this.store.select(selectMasterAccount),
            this.store.select (selectSubAccountId)
        ]),
        exhaustMap(([action, masterAccount, subAccount]) => {
            let request: VerifyTaxWithholdingsRequest = {
                stateTaxRate: action.stateTaxRate,
                fedTaxRate: action.fedTaxRate,
                masterAccount: parseInt(masterAccount)
            };
            return this.statusViewService.verifyTaxWithholdings(request, subAccount).pipe(map((response: VerifyTaxWithholdingsResponse) => {
                return AccountInfoActions.verifyTaxWithholdingsSuccess({ response });
            }),
            catchError((err: ServiceErrorAccountData) => {
                return of(AccountInfoActions.verifyTaxWithholdingsFailure(err));
            }))
        }))
    )

    submitTaxWithholdings$ = createEffect(() =>
        this.actions$.pipe(ofType(
            AccountInfoActions.submitTaxWithholdings
        ),
        concatLatestFrom(() => [
            this.store.select (selectSubAccountId)
        ]),
        exhaustMap(([action, subAccount]) => {
            let request: SubmitTaxWithholdingsRequest = {
                stateTaxRate: action.stateTaxRate,
                fedTaxRate: action.fedTaxRate
            };
            return this.statusViewService.submitTaxWithholdings(request, subAccount).pipe(map(() => {
                return AccountInfoActions.submitTaxWithholdingsSuccess();
            }),
            catchError((err: ServiceErrorAccountData) => {
                return of(AccountInfoActions.submitTaxWithholdingsFailure(err));
            }))
        }))
    )
}